import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductListCard from '../Shared/ProductListCard';
import Icon from '../Shared/Icon';
import classNames from 'classnames';

const Seller = () => {
     const { auth, data, caption } = usePage().props;
     return (
          <React.Fragment>
               <Helmet>
                    <title>{caption.sellers}</title>
               </Helmet>
               <section className="w-full pt-10 pb-10 bg-white">
                    <div className="w-full md:container mx-auto">
                         <div className="w-full mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-800">{caption.sellers}</h1>
                         </div>
                         <div className="w-full md:flex">
                              <div className="p-4 grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-2 md:grid-cols-4 md:gap-6">
                                   {data.map(({name, photo, role, zone},i)=>{
                                        return <div key={`dem${i}`} class="w-full flex items-center rounded-full bg-gray-100 h-24 p-2 shadow-inner">
                                             <img className="flex rounded-full float-left h-full transform hover:rotate-12" src={photo} />
                                             <div className="ml-2 p-2">
                                                  <h3 className="w-full text-md font-base text-emerald-700">{name}</h3>
                                                  <span className="w-full text-center text-sm text-gray-400">{role} {zone}</span>
                                             </div>
                                        </div>
                                   })}
                              </div>
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Seller.layout = page => <SiteLayout children={page} header={'Demarcheurs'} />;

export default Seller;
